import { Component, OnInit, Inject } from '@angular/core';
declare var require: any;
import { TableListComponent } from '../table-list.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
const pdfMakeX = require('pdfmake/build/pdfmake.js');
const pdfFontsX = require('pdfmake-unicode/dist/pdfmake-unicode.js');
pdfMakeX.vfs = pdfFontsX.pdfMake.vfs;
import * as pdfMake from 'pdfmake/build/pdfmake';

@Component({
  selector: 'app-bottom-sheet',
  templateUrl: './bottom-sheet.component.html',
  styleUrls: ['./bottom-sheet.component.scss']
})
export class BottomSheetComponent implements OnInit {
  public value = '';
  constructor(
    public dialogRef: MatDialogRef<TableListComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  toPdf() {
    const htmlToPdfmake = require('html-to-pdfmake');
    const html = htmlToPdfmake(this.data.pdf);
    const docDefinition = {
      content: [
        html
      ],
      styles: {
      }
    };
    const win = window.open('', '_blank');
    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.open({}, win);
  }

  findInText() {
    $('#innerPDF p').css('margin', '0px');
    $('#innerPDF p').css('color', 'black');
    const testBalise = new RegExp('strong|stron|stro');
    if (this.value === '' || this.value.length <= 3 || testBalise.test(this.value)) {
      return this.data.pdf;
    }
    return this.data.pdf.replace(new RegExp(this.value, 'gi'), match => {
      return '<span class="highlightText" style="background-color:#2ead2e !important;color:white !important">' + match + '</span>';
    });
  }

  ngOnInit() { }
}
